/** Сколько карточек выдачи добавляется за один шаг подгрузки при скролле. */
export const SERP_LIST_PAGE_SIZE = 5;

export const SERP_LIST_LOAD_DISTANCE = 300;

export const SERP_SHORT_MAX_CARDS = 5;

export const SERP_FILTERS_PAGE_SIZE = 6;

export const SERP_FILTERS_LOAD_DISTANCE = 100;
